module.exports = __webpack_public_path__ + "assets/img/fbfe6ab5ec2a50cd5f3e00b007e26575.svg";